import type { ComponentStyleConfig } from '@chakra-ui/react';

export const ButtonComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: '999px',
  },
};
